<template>
  <div style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24" style="float:left;">
        <!-- <el-button size="small" class="btn" type="primary" @click="handleCreate">报废审核</el-button> -->
        <!-- <el-button size="small" type="primary" disabled="true" class="btn">导出列表</el-button> -->
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item label="日期">
            <el-date-picker v-model="deviceInfo.date" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入搜索内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="scrapData" tooltip-effect="dark"
          style="width: 100%;text-align: center" stripe>
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column :label="lable.index" type="index"  show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" :label="lable.id" width="170">
            <template slot-scope="scope" show-overflow-tooltip>
              <!-- <el-button @click="onClick(scope.row)" type="text" size="small"> {{ scope.row.id }}</el-button> -->
              <el-link :underline="false" @click="onClick(scope.row)" style="color: #4095E5;text-decoration: none;">
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="glbh" :label="lable.glbh" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="zcmc" :label="lable.zcmc" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="ssdw" :label="lable.ssdw" show-overflow-tooltip>
          </el-table-column>

          <el-table-column sortable prop="scrapTime" :formatter="formateTime" :label="lable.scrapTime"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="userName" :label="lable.userName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="companyName" :label="lable.companyName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="scrapReson" :label="lable.scrapReson" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="method" :label="lable.method" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="statue" :label="lable.statue" show-overflow-tooltp>
            <template slot-scope="scope">
              <span v-if="scope.row.statue == '1'" style="color:#4095E5">待审核</span>
              <span v-else-if="scope.row.statue == '1.5'" style="color:#4095E5">待审核</span>
            </template>
          </el-table-column>
          <!-- <el-table-column :label="lable.cz" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click="selectClick(scope.row)" type="text"  size="small">详情</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="scrapData.length > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>
    <!--------------------------------------------------------------------报废审核弹框--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" title="报废审核"
      style="width:90% !important;margin-left: 200px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left:5%;">

        <el-row>
          <el-col :span="12">
            <el-form-item label="资产编号" style="width:90%">
              <el-input v-model="questionForm.deviceId" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.zcmc">
              <el-input v-model="questionForm.zcmc" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="资产型号" style="width:90%">
              <el-input v-model="questionForm.sbxh" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.scrapTime">
              <el-input v-model="questionForm.scrapTime" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.scrapReson" style="width:90%">
              <el-input v-model="questionForm.scrapReson" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.userName">
              <el-input v-model="questionForm.userName" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="申请日期" style="width:90%">
              <el-input v-model="questionForm.sqrq" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.companyName">
              <el-input v-model="questionForm.companyName" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="业务流程信息">
          <el-table :data="tableData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="createTime" label="时间" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="nodeName" label="事件" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="workflowResult" label="审批结果" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="bz" label="审核意见" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ssdw" label="单位" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="userId" label="操作人" show-overflow-tooltip>
            </el-table-column>

          </el-table>
        </el-form-item>
        <!-- <el-form-item label="审核结果">
          <el-radio-group style="width:100%" v-model="questionForm.sout">
            <el-radio label="0">通过</el-radio>
            <el-radio label="1">驳回</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="审核意见">
          <el-input type="textarea" :rows="2" placeholder="请输入审核意见" v-model="questionForm.ssyj" />
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table :data="fileData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot-scope="scope">
                <el-button @click="yulan(scope.row)" type="text" size="small">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" type="primary" @click="submitUpdate" v-preventReClick>通过</el-button>
        <el-button style="margin-left: 10px" type="danger" @click="noAuidt" v-preventReClick>驳回</el-button>

        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>

<script>

import { findByIdFile, approveByIdScrap, auditScrap, findByIdWorkflow, findByModule } from "../../api/api";

import FilePreview from '../../components/preview/FilePreview.vue'

export default {
  name: "Examine",
  components: {
    "FilePreview": FilePreview,

  },
  data() {
    return {
      deviceInfo: {
        date: [],
        content: "",
        state: "",
      },
      show: {},
      tableData: [],
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      lable: {},
      docxdialog: false,
      previewTitle: '',
      scrapData: [],
      multipleTable: [],
      dialogFormVisible: false,
      questionForm: {},
      options: [],
      fileData: [],
    };
  },

  methods: {
    downloading(scop) {
      // debugger
      this.downloadUtil.downloadFile(scop.path, scop.name);
    },

    yulan(row) {
      if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
        this.previewTitle = "图片预览"
      } else {
        this.previewTitle = "文件预览"
      }
      this.docxdialog = true
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.path)
      })
      // this.downloadUtil.preview(row.path)
    },
    // 格式化时间显示到日期
    formateTime(row) {
      let nowData = new Date(row.scrapTime)
      let year = nowData.getFullYear();
      let month = (nowData.getMonth() + 1).toString().padStart(2, '0');
      let date = nowData.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${date}`;
    },
    onClick(row) {
      if (this.show.sh) {
        this.questionForm = row
        this.findByIdfile(row.id);
        this.dialogFormVisible = true;
        this.findByIdWork(row.id)
      } else {
        this.$message.warning("您不具有该权限")
      }
    },
    handleClick(row) {
    },

    //根据id查找业务流程信息
    findByIdWork(row) {
      findByIdWorkflow(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.tableData = data;
          // debugger
        }
      });
    },
    handleCreate() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error("只能选择一个设备"); // .....失败信息
      } else if (currentSelect.length == 1) {
        this.questionForm = currentSelect[0]
        this.findByIdfile(currentSelect[0].id);
        this.findByIdWork(currentSelect[0].id)

        this.dialogFormVisible = true;
      } else {
        this.$message.error("请选择设备"); // .....失败信息
      }
    },
    submitUpdate() {
      this.questionForm.sout = 0
      this.audit(this.questionForm);
    },
    noAuidt() {
      this.questionForm.sout = 1
      this.audit(this.questionForm);
    },
    findAllClick(){
      this.pageIndex=1;
      this.findAll()
    },
    //审核
    audit(row) {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      var map = row
      map.userId = userinfo.userId
      auditScrap(map).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 200) {
          this.dialogFormVisible = false;
          this.findAll();
          this.$message({
            message: "审核成功",
            type: "success"
          });
        }
      });
    },
    //根据id查找文件
    findByIdfile(id) {
      findByIdFile(id).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.fileData = data;
          // debugger
        }
      });
    },

    //查找所有维保信息
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        state: 1,
        userId: userinfo.userId
      };
      approveByIdScrap(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }
          this.scrapData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize);
          this.total = this.data.length;
        }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.scrapData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.scrapData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
    },
    findLable() {
      findByModule("报废管理").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
  },
  created() {
    this.findLable();
    this.findAll();
    var userinfo = JSON.parse(localStorage.getItem("user"))
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "111") {
        this.show.sh = true;
      }
    })
  },
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>

<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/scrap/Examine.vue